import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface OfferListColumnsState {
  visibleKeys: Record<string, boolean>;
}

const initialState: OfferListColumnsState = {
  visibleKeys: {},
};

export const offerListColumnsSlice = createSlice({
  name: 'offerListColumns',
  initialState,
  reducers: {
    setVisibleKeys: (state, action: PayloadAction<Record<string, boolean>>) => {
      state.visibleKeys = action.payload;
    },
    setColumnVisibility: (
      state,
      action: PayloadAction<{ key: string; visible: boolean }>
    ) => {
      const { key, visible } = action.payload;
      state.visibleKeys[key] = visible;
    },
  },
});

export const { setVisibleKeys, setColumnVisibility } =
  offerListColumnsSlice.actions;
export default offerListColumnsSlice.reducer;
